import profile from './profile';

let messages = Object.assign({}, profile);

export default messages;
